import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';

export default class TSApplicationProperty extends TSAbstractEntity implements TSSerializable<TSApplicationProperty> {

    private _name: string | undefined;
    private _value: string | undefined;

    constructor(name?: string, value?: string) {
        super();
        this._name = name;
        this._value = value;
    }

    public set name(name: string | undefined) {
        this._name = name;
    }

    public set value(value: string | undefined) {
        this._value = value;
    }

    public get name(): string | undefined {
        return this._name;
    }

    public get value(): string | undefined {
        return this._value;
    }

    deserialize(restObject: any): TSApplicationProperty {
        super.deserialize(restObject);

        this.value = restObject.value;
        this.name = restObject.name;
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.name = this.name;
        restObject.value = this.value;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSApplicationProperty.ts